import { useState } from "react";
import { faqList } from "../content";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="mx-auto max-w-4xl scroll-mt-20 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <p className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-800">
          <i className="ri-question-line" /> 常见问题
        </p>
        <h2 className="mt-4 text-2xl font-bold text-foreground-950 md:text-4xl">关于互换与检测，你可能想问</h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
          把最高频的疑问集中在这里，弄懂这几点，多地址互换基本就畅通无阻了。
        </p>
      </div>

      <div className="mt-8 space-y-3">
        {faqList.map((item, idx) => {
          const active = openIdx === idx;
          return (
            <div
              key={item.q}
              className={`overflow-hidden rounded-2xl border transition-colors ${
                active ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-100/60"
              }`}
            >
              <button
                type="button"
                onClick={() => setOpenIdx(active ? null : idx)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
              >
                <span className="flex items-start gap-3">
                  <span
                    className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                      active ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    {idx + 1}
                  </span>
                  <span className="text-sm font-semibold text-foreground-900 md:text-base">{item.q}</span>
                </span>
                <i
                  className={`ri-add-line shrink-0 text-lg text-foreground-500 transition-transform ${active ? "rotate-45 text-primary-600" : ""}`}
                >
                </i>
              </button>
              {active && (
                <div className="px-5 pb-5 pl-14">
                  <p className="text-sm leading-relaxed text-foreground-700 md:text-base">{item.a}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-2xl border border-accent-200 bg-accent-100 p-6 text-center sm:flex-row sm:text-left">
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-accent-500 text-xl text-background-50">
            <i className="ri-customer-service-2-line" />
          </span>
          <div>
            <h3 className="font-bold text-foreground-950">还没解决你的问题？</h3>
            <p className="mt-0.5 text-sm text-foreground-700">欢迎通过下方联系方式留言，看到会尽快回复。</p>
          </div>
        </div>
        <a
          href="#contact"
          className="inline-flex items-center whitespace-nowrap rounded-full bg-foreground-900 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800"
        >
          联系站长
          <i className="ri-send-plane-line ml-2" />
        </a>
      </div>
    </section>
  );
}